import React from 'react';
import cx from 'classnames';

const Skeleton = ({ className, ...props }) => {
    return <div className={cx("commonSkeletonBox", className)} {...props} />;
};

export default Skeleton;